/**
 * Six-trait horizontal bar chart — pure HTML/CSS, no canvas, no library, no
 * PNG. Trait names, values and notes are real text nodes so Google can crawl
 * them and users can select them. Same palette as BlogCTA.
 *
 * Props:
 *   scores: [{ trait?: string, label: string, value: number (0-100), note?: string }]
 *   title?: string
 *   testid?: string
 */
export default function SixTraitChart({ scores = [], title, testid = "six-trait-chart" }) {
  return (
    <figure
      className="six-trait-chart"
      data-testid={testid}
      aria-label={title || "Six-trait profile"}
    >
      {title && (
        <figcaption
          className="six-trait-chart-title"
          data-testid={`${testid}-title`}
        >
          {title}
        </figcaption>
      )}
      <ul className="six-trait-chart-list" role="list">
        {scores.map((s) => {
          const value = Math.max(0, Math.min(100, s.value));
          return (
            <li
              key={s.label}
              className="six-trait-chart-row"
              data-testid={`${testid}-row-${s.label.toLowerCase()}`}
            >
              <div className="six-trait-chart-head">
                <span
                  className="six-trait-chart-label"
                  data-testid={`${testid}-label-${s.label.toLowerCase()}`}
                >
                  {s.label}
                </span>
                <span
                  className="six-trait-chart-value"
                  data-testid={`${testid}-value-${s.label.toLowerCase()}`}
                >
                  {value}
                </span>
              </div>
              <div
                className="six-trait-chart-bar"
                role="img"
                aria-valuenow={value}
                aria-valuemin={0}
                aria-valuemax={100}
                aria-label={`${s.label} ${value} out of 100`}
              >
                <div
                  className="six-trait-chart-fill"
                  style={{ width: `${value}%` }}
                />
              </div>
              {s.note && (
                <p
                  className="six-trait-chart-note"
                  data-testid={`${testid}-note-${s.label.toLowerCase()}`}
                >
                  {s.note}
                </p>
              )}
            </li>
          );
        })}
      </ul>
    </figure>
  );
}
